window.Events = {
  closeClass: "h-help-center__close",

  setup: function (container, toggler) {
    var self = this;

    toggler.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.Modal.toggle();
    });

    var closeEl = container.querySelector("." + this.closeClass);
    if (closeEl) {
      closeEl.addEventListener("click", function (e) {
        e.preventDefault();
        window.Modal.close();
      });
    }

    var buttons = [
      { selector: ".h-help-center__chat", tab: "chat", track: "ChatOpened" },
      { selector: ".h-help-center__beacon", tab: "helpdesk", track: null },
      {
        selector: ".h-help-center__trainings",
        tab: null,
        track: "TrainingsOpened",
      },
    ];

    buttons.forEach(function (btn) {
      var el = container.querySelector(btn.selector);
      if (!el) return;

      el.addEventListener("click", function (e) {
        if (btn.tab) {
          e.preventDefault();
          window.Crisp.toggle(btn.tab);
        }

        if (btn.track && window.productAnalytics) {
          window.productAnalytics.track(btn.track);
        }
      });
    });

    document.addEventListener("click", function (e) {
      if (
        e.target.closest(
          "mobile-menu.menu-toggle, mobile-menu.modern-nav-toggle",
        )
      ) {
        window.Modal.close();
      }
    });
  },
};
